module.exports = __webpack_public_path__ + "img/cctv.d364012a.jpeg";